const { Form } = require("mobx-react-form");

import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

import formObserver from './observers';
import setInitialDefaults from './initialDefaults.js';
import * as keys from './keys';
import Utils from './utils';
import * as Constants from 'constants/Constants'

class PGSProFormController extends Form {
    plugins() {
        return {
            dvr: dvr(validatorjs)
        }
    }

    setup() {
        return {
            fields: [
                {
                    name: "PPT",
                    label: "Premium Paying Term",
                    placeholder: "Select",
                    disabled: false,
                    extra: {
                        optionList: [],
                    }
                },
                {
                    name: "PT",
                    label: "Policy Term",
                    placeholder: "Select",
                    disabled: false,
                    extra: {
                        optionList: [
                            { label: '15', id: '15' },
                            { label: '20', id: '20' },
                            { label: '25', id: '25' },
                            { label: '30', id: '30' },
                            { label: '100', id: '100' }
                        ],
                    }
                },

                {
                    name: "lump-sum-benefit",
                    label: "Lump Sum Benefit",
                    placeholder: "Select",
                    extra: {
                        hide: false,
                        optionList: [{ label: 'No', id: '2' }, { label: 'Yes', id: '1' }]
                    },
                },
                {
                    name: "payment-frequency",
                    label: "Premium Paying Frequency",
                    placeholder: "",
                    extra: {
                        optionList: [
                            { label: 'Annual', id: '1' },
                            { label: 'Semi-Annual', id: '2' },
                            { label: 'Quarterly', id: '3' },
                            { label: 'Monthly', id: '4' }
                        ],
                    }
                },
                {
                    name: "income-benefit-pay-out-frequency",
                    label: "Income Benefit Pay-out Frequency",
                    placeholder: "Select",
                    // disabled: true,
                    extra: {
                        hide: false,
                        optionList: [
                            { label: 'Annual', id: '24' },
                            { label: 'Semi-Annual', id: '25' },
                            { label: 'Quarterly', id: '26' },
                            { label: 'Monthly', id: '27' }
                        ]
                    }
                },

                {
                    name: "death-benefit-option",
                    label: "Death Benefit Option",
                    placeholder: "",
                    disabled: false,
                    extra: {
                        optionList: []
                    },
                },
                {
                    name: "plan-option",
                    label: "Plan Option",
                    placeholder: "",
                    disabled: false,
                    extra: {
                        optionList: [
                            { label: "Lump Sum", id: 1, },
                            { label: "Lump Sum Plus Income", id: 2, }
                        ]
                    },
                },
                {
                    name: "ecs-mandate-auto-debit",
                    label: "want to register for ECS Mandate/Auto-debit?",
                    placeholder: "",
                    disabled: false,
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 1 },
                            { label: 'No', id: 2 },
                        ]
                    },
                },
                {
                    name: "is-existing-customer",
                    label: "Are you an Existing Customer?",
                    placeholder: "",
                    disabled: false,
                    extra: {
                        showExistingCustomerModal: false,
                        optionList: [
                            { label: 'Yes', id: 1 },
                            { label: 'No', id: 2 },
                        ],
                        toggleIsExistingCustomerModal(form, status) {
                            form.$("is-existing-customer").set("extra", {
                                ...form.$("is-existing-customer").extra,
                                showExistingCustomerModal: status,

                            });
                        },
                    },
                },
                {
                    name: "income-benefit-payout-start-year",
                    label: "Income Benefit Payout Start Year",
                    placeholder: "",
                    disabled: false,
                    extra: {
                        optionList: []
                    },
                },
                {
                    name: "income-duration",
                    label: "Income duration (in years)",
                    placeholder: "",
                    disabled: false,
                    extra: {
                        optionList: []
                    },
                },
                {
                    name: "annualised-premium",
                    label: "Annualised Premium",
                    value: "",
                },
                // Rider
                {
                    name: 'WaiverOfPremiumRider',
                    label: 'Waiver of Premium',
                    placeholder: '',
                    value: false,
                    disabled: false,
                    extra: {
                        description: Constants.WOP_RIDER_DESCRIPTION,
                        paramName: 'WaiverOfPremiumRider',
                        rider_name: 'Waiver of Premium Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('WaiverOfPremiumRider').value
                            let productId = data.data.package_id
                            let wopRiderValue = '';

                            if (!value) {
                                wopRiderValue = '1';
                            }
                            form.$('WaiverOfPremiumRider').value = !value

                            Utils.updateBi(keys.WOP_RIDER, wopRiderValue, productId, form, data)
                        }
                    }
                },
                {
                    name: 'ADB',
                    label: 'Accidental Death Benefit',
                    placeholder: '',
                    value: false,
                    extra: {
                        description: Constants.ADB_RIDER_DESCRIPTION,
                        paramName: 'ADBRider',
                        rider_name: 'ADB Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('ADB').value
                            form.$('ADB').value = !value

                            if (form.$('ADB').value) {
                                form.$('ADB-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                            } else {
                                form.$('ADB-dropdown').set('value', "")
                            }
                        }
                    }
                },
                {
                    name: 'ADB-dropdown',
                    label: 'Accidental Death Benefit',
                    placeholder: '',
                    value: "",
                    extra: {
                        optionList: Utils.getAdbList(),
                        onBlur(form, data) {
                            let value = form.$("ADB-dropdown").value
                            Utils.updateBi(keys.ADB_RIDER, value, data.data.package_id, form, data)
                        },
                    },
                },
                {
                    name: 'ATPDRider',
                    label: 'Accidental Total and Permanent Disability',
                    placeholder: '',
                    value: false,
                    extra: {
                        description: Constants.ATPD_RIDER_DESCRIPTION,
                        paramName: 'ATPDRider',
                        rider_name: 'ATPD Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('ATPDRider').value
                            form.$('ATPDRider').value = !value

                            if (form.$('ATPDRider').value) {
                                form.$('ATPDRider-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                            } else {
                                form.$('ATPDRider-dropdown').set('value', "")
                            }
                        }

                    }
                },
                {
                    name: 'ATPDRider-dropdown',
                    label: 'Accidental Total and Permanent Disability',
                    placeholder: '',
                    value: "",
                    extra: {
                        optionList: Utils.getAtpdList(),
                        onBlur(form, data) {
                            let value = form.$("ATPDRider-dropdown").value
                            Utils.updateBi(keys.ATPD_RIDER, value, data.data.package_id, form, data)
                        },
                    }
                },
                {
                    name: 'CriticalIllnessRider',
                    label: 'Critical Illness',
                    placeholder: '',
                    value: false,
                    extra: {
                        description: Constants.CRITICAL_ILLNESS_RIDER_DESCRIPTION,
                        paramName: 'CriticalIllnessRider',
                        rider_name: 'Critical Illness Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('CriticalIllnessRider').value
                            form.$('CriticalIllnessRider').value = !value

                            if (form.$('CriticalIllnessRider').value) {
                                form.$('CriticalIllnessRider-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                            } else {
                                form.$('CriticalIllnessRider-dropdown').set('value', "")
                            }
                        }
                    }
                },
                {
                    name: 'CriticalIllnessRider-dropdown',
                    label: 'Critical Illness',
                    placeholder: '',
                    value: "",
                    extra: {
                        optionList: Utils.getCriticalIllnessList(),
                        onBlur(form, data) {
                            let value = form.$("CriticalIllnessRider-dropdown").value
                            Utils.updateBi(keys.Critical_ILLNESS_RIDER, value, data.data.package_id, form, data)
                        },
                    }
                },
                {
                    name: 'PayorWaiverBenefitRider',
                    label: 'Payor Waivor Benefit',
                    placeholder: '',
                    disabled: false,
                    value: false,
                    extra: {
                        description: Constants.PWB_RIDER_DESCRIPTION,
                        paramName: 'PayorWaiverBenefitRider',
                        rider_name: 'Payor Waiver Benefit Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('PayorWaiverBenefitRider').value
                            form.$('PayorWaiverBenefitRider').value = !value

                            if (form.$('PayorWaiverBenefitRider').value) {
                                form.$('PayorWaiverBenefitRider-dropdown').set('value', form.$('PayorWaiverBenefitRider-dropdown').extra.optionList[0])
                            } else {
                                form.$('PayorWaiverBenefitRider-dropdown').set('value', {})
                            }
                        }
                    }
                },
                {
                    name: 'PayorWaiverBenefitRider-dropdown',
                    label: 'Payor Waivor Benefit',
                    placeholder: '',
                    value: {},
                    extra: {
                        optionList: [
                            { id: 1, label: 'Option 1 (On Death)' },
                            { id: 2, label: 'Option 2 (CI or ATPD)' },
                            { id: 3, label: 'Option 3 (CI or ATPD or Death)' },
                        ]
                    }
                },
                {
                    name: 'HospitalityCashBenefitRider',
                    label: 'Hospital Cash Benefit',
                    placeholder: '',
                    value: false,
                    extra: {
                        description: Constants.HOSPITALITY_CASH_BENEFIT_RIDER_DESCRIPTION,
                        paramName: 'HospitalityCashBenefitRider',
                        rider_name: 'Hospital Cash Benefit Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('HospitalityCashBenefitRider').value
                            form.$('HospitalityCashBenefitRider').value = !value

                            if (form.$('HospitalityCashBenefitRider').value) {
                                form.$('HospitalityCashBenefitRider-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                            } else {
                                form.$('HospitalityCashBenefitRider-dropdown').set('value', "")
                            }

                        }

                    }
                },

                {
                    name: 'HospitalityCashBenefitRider-dropdown',
                    label: 'Hospital Cash Benefit',
                    placeholder: '',
                    value: "",
                    extra: {
                        optionList: [],
                        onBlur(form, data) {
                            let value = form.$("HospitalityCashBenefitRider-dropdown").value
                            Utils.updateBi(keys.HOSPITALITY_CASH_BENEFIT_RIDER, value, data.data.package_id, form, data)
                        },
                    }
                },
                {
                    name: "premium",
                    label: "Premium",
                    placeholder: "",
                    disabled: true,
                    extra: {
                        calculatePremiun(form, productId, data) {

                        }
                    }
                },
            ]
        }
    }

    setDefaults(data) {
        // Set forms initial default value
        setInitialDefaults(this, data?.data)

        // Observer fields
        formObserver(this, data?.data)
    }

}

export default PGSProFormController;
